<script setup lang="ts">
import MxButton from '@/components/MxButton.vue';
import MxIcon from '@/components/MxIcon.vue';
</script>

<template>
  <section class="tf">
    <MxIcon name="XCircle" :size="64" />
    <h1>Платёж отменён</h1>
    <p>Вы можете попробовать снова.</p>
    <RouterLink to="/topup">
      <MxButton variant="primary">Попробовать снова</MxButton>
    </RouterLink>
  </section>
</template>

<style scoped>
.tf { padding: var(--sp-12) var(--sp-4); display: flex; flex-direction: column; align-items: center; gap: var(--sp-3); text-align: center; color: var(--error); }
.tf h1 { font-family: var(--font-display); font-size: var(--fs-2xl); color: var(--text-primary); }
.tf p { color: var(--text-secondary); }
</style>
